import SubscriptionGate from '../components/Subscriptions/SubscriptionGate'
import AddNewAsset from '../pages/fleetEquipment/assetManager/AddNewAsset'
import AssetManager from '../pages/fleetEquipment/assetManager/Assets'
import SingleAsset from '../pages/fleetEquipment/assetManager/SingleAsset/SingleAsset'
import AddNewDefect from '../pages/fleetEquipment/defects/AddNewDefect'
import Defects from '../pages/fleetEquipment/defects/Defects'
import SingleDefect from '../pages/fleetEquipment/defects/SingleDefect/SingleDefect'
import MakeReady from '../pages/fleetEquipment/makeReady/MakeReady'
import MakeReadyOverview from '../pages/fleetEquipment/makeReadyOverview/MakeReadyOverview'
import MakeReadyHistory from '../pages/fleetEquipment/makeReadyOverview/MakeReadyHistory'
import RestockQueue from '../pages/fleetEquipment/makeReadyOverview/RestockQueue'
import MakeReadyModuleLayout from '../pages/fleetEquipment/makeReadyModule/MakeReadyModuleLayout'
import LoadLists from '../pages/fleetEquipment/makeReadyLoadLists/LoadLists'
import LoadListBuilder from '../pages/fleetEquipment/makeReadyLoadLists/LoadListBuilder'
import MakeReadyWizard from '../pages/fleetEquipment/makeReadyLoadLists/MakeReadyWizard'
import StartOfShiftCheck from '../pages/fleetEquipment/startOfShift/StartOfShiftCheck'
import VDIForm from '../pages/fleetEquipment/VDIForm/VDIForm'
import VDIReport from '../pages/fleetEquipment/vehicles/completedVDIs/VDIReport'
import CompletedVDIs from '../pages/fleetEquipment/vehicles/completedVDIs/VDIs'
import NewSafetyCheck from '../pages/fleetEquipment/vehicles/SafetyCheck/NewSafetyCheck'
import SafetyChecks from '../pages/fleetEquipment/vehicles/SafetyCheck/SafetyChecks'
import VehicleSafetyCheckReport from '../pages/fleetEquipment/vehicles/SafetyCheck/VehicleSafetyCheckReport'
import SingleVehicle from '../pages/fleetEquipment/vehicles/SingleVehicle'
import Vehicles from '../pages/fleetEquipment/vehicles/vehicles'
import CleaningSchedules from '../pages/governance/cleaningSchedules/CleaningSchedules'
import VehicleCleanForm from '../pages/governance/cleaningSchedules/VehicleCleanForm/VehicleCleanForm'
import RecordFuel from '../pages/fleetEquipment/fuel/RecordFuel'
import VehicleCleanReport from '../pages/governance/cleaningSchedules/VehicleCleanReport/VehicleCleanReport'

export default [
  { path: '/fleet', element: <Vehicles />, title: 'Fleet' },
  { path: '/fleet/record-safety-check', element: <NewSafetyCheck />, title: 'New Safety Check' },
  {
    path: '/fleet/vehicle-safety-check/:reportID',
    element: <VehicleSafetyCheckReport />,
    title: 'Safety Check'
  },
  {
    path: '/fleet/vehicle-safety-check/:reportID/edit',
    element: <NewSafetyCheck />,
    title: 'Amend Safety Check'
  },
  { path: '/safety-checks', element: <SafetyChecks />, title: 'Safety Checks' },
  { path: '/fleet/:fleetId', element: <SingleVehicle /> },
  { path: '/cleaning-schedules', element: <CleaningSchedules />, title: 'Cleaning Schedules' },
  { path: '/vdis', element: <CompletedVDIs />, title: 'VDIs' },
  { path: '/vdis/:id', element: <VDIReport />, title: 'VDI Report' },
  { path: '/defects', element: <Defects />, title: 'Defects' },
  { path: '/defects/:defectId', element: <SingleDefect />, title: 'Defect' },
  {
    element: <SubscriptionGate requiredTier={2} featureName="Make Ready" />,
    children: [
      {
        element: <MakeReadyModuleLayout />,
        children: [
          { path: '/make-ready-overview', element: <MakeReadyOverview />, title: 'Make Ready' },
          { path: '/make-ready-history', element: <MakeReadyHistory />, title: 'Make Ready' },
          { path: '/make-ready-load-lists', element: <LoadLists />, title: 'Load Lists' },
          {
            path: '/make-ready-load-lists/setup',
            element: <MakeReadyWizard />,
            title: 'Load Lists'
          },
          {
            path: '/make-ready-load-lists/new',
            element: <LoadListBuilder />,
            title: 'New Load List'
          },
          {
            path: '/make-ready-load-lists/:loadListID',
            element: <LoadListBuilder />,
            title: 'Load List'
          },
        ],
      },
      { path: '/make-ready-restock-queue', element: <RestockQueue />, title: 'Restock Queue' },
      { path: '/make-ready/:callsignAssetID', element: <MakeReady />, title: 'Make Ready' },
    ],
  },
  { path: '/report-defect', element: <AddNewDefect />, title: 'Report a Defect' },
  { path: '/asset-manager', element: <AssetManager />, title: 'Asset Manager' },
  { path: '/asset-manager/add-new', element: <AddNewAsset />, title: 'Add Asset' },
  { path: '/asset-manager/:assetID', element: <SingleAsset /> },
  { path: '/vdi', element: <VDIForm />, title: 'VDI' },
  { path: '/start-of-shift', element: <StartOfShiftCheck />, title: 'Start of Shift Check' },
  { path: '/vehicle-clean', element: <VehicleCleanForm />, title: 'Vehicle Clean' },
  { path: '/vehicle-clean/:id', element: <VehicleCleanReport />, title: 'Vehicle Clean' },
  { path: '/record-fuel', element: <RecordFuel />, title: 'Record Fuel' },
]
